import React from 'react';
import { render } from 'react-dom';
import App from '../src/components/app/App.jsx';

render(
  <App />,
  document.getElementById('root')
);
